<template>
  <div class="main-guide full">
    <Modal v-if="propsData.mainGuideShowModal">
      <template v-slot:body>
        <div class="swiper-wrap" v-if="guideData">
          <swiper
              :pagination="true"
              :modules="modules"
              @swiper="onSwiper"
              :preventInteractionOnTransition="false"
              class="mySwiper" ref="mySwiper" @click="closePopup">
            <swiper-slide v-for="(item, index) in guideData" :key="item">
              <h1 class="swiper-title">
                <img :src="item.img1" alt="title">
              </h1>
              <div class="swiper-contents">
                <img :src="item.img2" alt="contents" v-if="item.img2">
                <div v-else v-html="item.text"></div>
              </div>
              <div class="swiper-image">
                <img :src="item.img3" alt="내용 이미지">
              </div>
              <div v-show="index === 3">
                <button type="button" class="btn-big btn-blue" @click="closePopup">시작하기</button>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </template>
      <template v-slot:footer>
        <div>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import Modal from "@/components/modal.vue";
import {Swiper, SwiperSlide} from "swiper/vue";
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

export default {
  name: "comp-main-guide",
  components: {
    SwiperSlide,
    Swiper,
    Modal
  },
  props: {
    propsData: {
      mainGuideShowModal: Boolean
    }
  },
  data (){
    return {
      modules : [Pagination],
      guideData : [
        {
          img1 : require('@/assets/images/main/img_main_guide_title_01.webp'),
          img2 : require('@/assets/images/main/img_main_guide_text_01.webp'),
          text : '<p>자녀가 학습중인 콘텐츠에 해당하는<br>학습 지도 가이드를 쉽게 확인할 수 있습니다.</p>',
          img3 : require('@/assets/images/main/img_tutorial_01.webp')
        },
        {
          img1 : require('@/assets/images/main/img_main_guide_title_02.webp'),
          text : '<p>자녀가 학습중인 콘텐츠에 해당하는<br>학습 지도 가이드를 쉽게 확인할 수 있습니다.</p>',
          img3 : require('@/assets/images/main/img_tutorial_02.webp')
        },
        {
          img1 : require('@/assets/images/main/img_main_guide_title_03.webp'),
          text : '<p>책 특징 및 줄거리 정보, 질문과 대화를 통해<br>자녀의 생각을 키우는 북토킹 가이드를 제공합니다.</p>',
          img3 : require('@/assets/images/main/img_tutorial_03.png')
        },
        {
          img1 : require('@/assets/images/main/img_main_guide_title_04.webp'),
          text : '<p>책 내용의 전체 해석과 꼭 알아야 할<br>주요 영단어 뜻을 제공합니다.</p>',
          img3 : require('@/assets/images/main/img_tutorial_04.png')
        }
      ]
    }
  },
  methods: {
    onSwiper(s) {
      this.mySwiper = s;
    },
    closePopup() {
      if (this.mySwiper.activeIndex === 3) {
        this.$emit('closePopup');
      }
    },
  },
}
</script>
